export default __webpack_public_path__ + "static/media/feature-website-3.62166a8d.png";